import React, { Component} from "react";
import "./NewestProjectStyle.css";
import ProjectCard from "./ProjectCard";

import {db} from '../firebase/Firebasedata';
import {collection, getDocs, orderBy,query,where, limit} from 'firebase/firestore';
import ProjectSelector from "./ProjectSelector";

import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useState } from "react";

import useScreenSize from "../Hooks/useScreenSize";

class NewestProject extends Component{
    
    constructor(props){  
        super(props);

        var allFilters = ["all","games","software","art"];
        var startVal = allFilters.indexOf(this.props.startWith.toLowerCase() ?? "") != -1 ? allFilters.indexOf(this.props.startWith.toLowerCase()) : 0;

        if (props.location.state?.lastFilterIndex !== -1 && props.location.state?.lastFilterIndex != null) {
            console.log("1" + props.location);
            console.log(props.location.state);
            startVal = props.location.state?.lastFilterIndex ?? 0;
        }

        this.state = {
            loadedProjects: false,
            //projects: [],
            skills:[],
            tabSelected:startVal,
            filters:allFilters,
            projectCount: 0
        };
    }  

    async getProjects(){

        this.props.setProjectsList([]);

        if (this.state.tabSelected == 0){
            const querySnapshot = await getDocs(query(collection(db,"Projects"),orderBy("order")));
            querySnapshot.forEach((d)=>{
                this.props.projectsList.push(d);
            });
            this.setState({loadedProjects:true,projectCount: this.props.projectsList.length});
        }else if (this.state.tabSelected == 1){
            const querySnapshot = await getDocs(query(collection(db,"Projects"),where("category","==","game")));
            querySnapshot.forEach((d)=>{
                this.props.projectsList.push(d);
            });
            this.setState({loadedProjects:true,projectCount: this.props.projectsList.length});
        }else if (this.state.tabSelected == 2){
            const querySnapshot = await getDocs(query(collection(db,"Projects"),where("category","==","software")));
            querySnapshot.forEach((d)=>{
                this.props.projectsList.push(d);
            });
            this.setState({loadedProjects:true,projectCount: this.props.projectsList.length});
        }else if (this.state.tabSelected == 3){
            const querySnapshot = await getDocs(query(collection(db,"Projects"),where("category","==","art")));
            querySnapshot.forEach((d)=>{
                this.props.projectsList.push(d);
            });
            this.setState({loadedProjects:true,projectCount: this.props.projectsList.length});
        }
    }

    handleTabChanged=(newIndex)=>{
        this.setState({loadedProjects: false,projectCount: 3});
        this.setState({ tabSelected: newIndex },()=>{
            this.getProjects();
        });
    };

    componentDidMount () {
        this.getProjects();
    }
    
    render(){
        var cols = Array(Math.min(this.state.projectCount, 3)).fill('380px').join(' ');

        if (this.props.screenWidth <= 900){
            cols = "1fr";
        }else if (this.props.screenWidth <= 1450){
            cols = "380px 380px";
        }

        var grid = <div className="project-grid" style={{ gridTemplateColumns: cols }}>
        {
            this.state.loadedProjects ? this.props.projectsList.map((project,i) => 
                <ProjectCard 
                key={i}
                useGhost={false}
                name={project.data().name}
                desc={project.data().desc}
                img={project.data().cover_img}
                time={project.data().time}
                projectID={project.id}
                skills={project.data().skills}
                category={project.data().category}
                lastFilterIndex={this.state.tabSelected}
                fadeDelay={i*0.1}/>) 
            : //<div className="loading">
                <>{Array.from({ length: 12 }).map((item, i) => (
                    <ProjectCard 
                    key={item}
                    useGhost={true}
                    lastFilterIndex={-1}
                    fadeDelay={i*0.5}/>
                ))}</>
            //</div>
        }
        </div>;

        // var noData = <div className="project-grid">
        // {
        //     <div className="loading">Adding projects 🎨 Come back another day...</div>
        // }
        // </div>; 
        
        // ;

        return <div id="projects" className="second-page">
            <div className="second-page-container">
                <h2 className="project-title">Projects</h2>

                <ProjectSelector 
                tabSelected={this.state.tabSelected} 
                tabChangeCallback={this.handleTabChanged} 
                options={this.state.filters}/>
                
                {grid}
                
            </div>
        </div>;
    }
}

export default function(props){
    const [list, setList] = useState([]);
    const {filterType} = useParams();
    const location = useLocation();
    const width = useScreenSize();
    return <NewestProject {...props} 
    projectsList={list} 
    setProjectsList={setList} 
    startWith={props.useFilter ? filterType : "all"} 
    location={location}
    screenWidth={width}/>;
}